export default __webpack_public_path__ + "static/media/video-cover.5625ba5e.png";